import "./Header.scss";
import React from "react";
import Nav from "../Nav/Nav";
import { Link } from "react-router-dom";

export default function header() {
  return (
    <header className="header">
      <Link to="/">
        <div className="header__logo"></div>
      </Link>
      <div className="header__text-wrap">
        <div className="header__text">Rate Your Landlord</div>
        <div className="header__sub-text">
          Redefining your rental experience
        </div>
      </div>
      <div className="header__nav--desktop">
        <Nav />
      </div>
    </header>
  );
}
